module.exports = __webpack_public_path__ + "774e6a16c327588cd54084c11cbd2f66.png";